<style lang="less">
.account{
	.account_head{
		//样式在 app.vue
	}
	.update{
		padding: 16px;
		overflow: hidden;
		.desc{
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			padding: 16px;
			background: #F7F8FB;
			h3{
				font-weight: 700;
				font-size: 14px;
				color: #2E4276;
			}
			p{
				opacity: 0.7;
				font-family: FlymeRegular;
				font-size: 12px;
				color: #2E4276;
			}
			.info{
				-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
				h3{
					padding-bottom: 6px;
				}
			}
			.price{
				text-align: center;
				h3{
					font-size: 24px;
					color: #DC2A2A;
					font-weight: 400;
					span{
						font-size: 18px;
					}
				}
			}
		}
		.foot_line{
			width: 100%;
			height: 1px;
			background: #D8D8D8;
			transform: scale(1,0.5);
		}
		.foot{
			background: #F7F8FB;
			font-size: 14px;
			color: #2E4276;
			font-weight: 700;
			text-align: center;
			p{
				padding: 12px;
			}
		}
	}
	.head_space{
		height: 30px;
		width: 100%;
	}
}
</style>

<template>
	<!-- Main account -->
	<section class="account">

		<toptips :tips="detail.message" v-if="showTopTips">
			<slot v-if="detail.status != 20">
				<router-link  class="toidentity" to="/verify">立即验证</router-link>
			</slot>
		</toptips>

		<div class="account_head">
			<h1 class="price NOFont">{{detail.acct_account_info.money || 0}}</h1>
			<div class="desc">总金额（元）</div>
			<!-- <div class="button">
				<button @click="account">开启收益</button>
			</div> -->
			<!-- <div class="info">
				<div class="item">
					<h3>活期</h3>
					<p>理财期限（天）</p>
				</div>
				<div class="item">
					<h3>1.00</h3>
					<p>起购金额（元）</p>
				</div>
			</div> -->
			<div class="head_space"></div>
		</div>

		<div class="char">
			<div class="update" v-if="identity_detail.age > 18">
				<div class="desc">
					<div class="info">
						<h3>升级享收益</h3>
						<p>存 1 万每月可赚 {{(Math.floor(10000 *( Math.pow( 1 + (product.rate/100),(1/365) )-1 ) * 100)/100 * 30).toFixed(2)}} 元</p>
					</div>
					<div class="price">
						<h3>{{product.rate}}<span>%</span></h3>
						<p>七日年化收益率</p>
					</div>
				</div>
				<div class="foot_line"></div>
				<div class="foot">
					<p @click="account">立即升级</p>
				</div>
			</div>
			<div class="title">
				<h3>七日年化收益率 {{product.rate}}% </h3>
				<p>万份收益：{{product.exp_per_profit}}元</p>
			</div>
			<div class="cont">
				<char :charData="product.history"></char>
			</div>
		</div>


		<div class="cp">{{config.cp}}</div>
		<div class="space"></div>
		<div class="space" v-if="identity_detail.age < 18"></div>

		<footbtn btn-txt="转入" btn-ext="取出" :is-on="isActive" :is-exton="isExtActive" v-on:next="next" v-on:ext="ext"></footbtn>

	</section>
</template>

<script>
	/*
		global track
		global Finish
	*/
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import android from '@flyme/jr/js/android.js';

	import toptips from '../components/toptips.vue';
	import agreement from '../components/agreement.vue';
	import itembank from '../components/itembank.vue';
	import char from '../components/char_2.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				config: config,
				agree: true,
				identity_detail: {},
				product: {
					history: {}
				},
				detail: {
					acct_account_info: {}
				},
				bank: {
					index: -1,
					isShow: false,
					data: []
				},
				cache: true
			};
		},
		computed: {
			isActive: function() {
				if (this.agree) {
					return true;
				}else{
					return false;
				}
			},
			isExtActive: function() {
				if (this.detail.acct_account_info.avaliable_bal > 0) {
					return true;
				}else{
					return false;
				}
			},
			showTopTips: function () {
				if (this.detail.acct_status === 0) {
					return true;
				} else{
					return false;
				}
			}
		},
		components: {
			itembank,
			toptips,
			footbtn,
			agreement,
			char
		},
		created: function () {
			android('setTitle', {
				title:"余额"
			});
			android('startLoading', {mes: '正在加载'});
			this.getAge();
			this.getDetail();
			this.initMenu();
			this.getProduct();
		},
		mounted: function () {
		},
		beforeDestroy: function () {
			this.removMenu();
		},
		methods: {
			getAge: function () {
				let _this = this;
				axios.post(apis.identity_query_detail, {
					show_type: 0
				}).then(function(d) {
					console.log('identity_query_detail', d);
					_this.identity_detail = d.value;
				});
			},
			initMenu: function () {
				let _this = this;
				android('addMenuItem', {
					key: 'order',
					text: '账单',
					enable: true
				}, function () {
					_this.orderList();
				});

			},
			removMenu: function () {
				android('removeAllMenuItem');
			},
			orderList: function () {
				let _this = this;
				android('startPageWithCallback', {
					url: config.staticURL + '/#/order/list',
					start_type:1,
					data:'',
					display:{
						title:'账单'
					}
				}, function () {
					_this.getDetail();
				});
			},
			account: function () {
				track('event_to_update_acctplus');
				// this.$router.replace({ path: 'verify' });
				android('startPageWithCallback', {
					url: config.staticURL + '/#/verify',
					start_type:1,
					data:'',
					display:{
						title:'验证身份'
					}
				}, function (d) {
					if (d.pages == 'Verify_result') {
						Finish('Verify_result');
					}
				});
			},
			getDetail: function () {
				if (this.$route.query.acct_query && this.cache) {
					this.detail = JSON.parse(this.$route.query.acct_query);
					// this.setDetail(d);
					this.cache = false;
					android('stopLoading');
					return;
				}

				let _this = this;
				axios.post(apis.acct_query, {
					show_type: 0
				}).then(function(d) {
					console.log('acct_query', d, d.value.acct_account_info);
					if (d.value.acct_status === 0) {
						//未开通，引导开通
						// _this.$router.push({path: '/identity'});
					}else{
						if (d.value.acct_account_info && d.value.acct_account_info.avaliable_bal) {
							d.value.acct_account_info.money = d.value.acct_account_info.avaliable_bal.Format();
						}
						if (d.value.acctplus_account_info && d.value.acctplus_account_info.avaliable_asset) {
							d.value.acctplus_account_info.money = d.value.acctplus_account_info.avaliable_asset.Format();
						}
						android('stopLoading');
						_this.detail = d.value;
					}
				});
			},
			getProduct: function () {
				let _this = this;
				axios.post(apis.acctplus_product_query, {
					show_type: 1
				}).then(function(d) {
					console.log('acctplus_product_query', d, d.value.history_rates);
					if (d.value) {
						d.value.history = {};
						_this.product = d.value;
						_this.getCharData();
					}
				});
			},
			getCharData: function () {
				var data = this.product.history_rates;
				var charData = {
					x: [],
					y: []
				};
				for( var i = data.length - 1; i >= 0; i--){
					charData.x.push(new Date(data[i].date).Format("MM/dd"));
					charData.y.push(data[i].rate);
				}
				console.log('product.history',charData);
				this.product.history = charData;
			},
			next: function () {
				// this.$router.push({path: '/account/charge'});

				let _this = this;
				android('startPageWithCallback', {
					url: config.staticURL + '/#/account/charge',
					start_type:1,
					data:'',
					display:{
						title:'转入'
					}
				}, function () {
					_this.getDetail();
				});

			},
			ext: function () {
				// this.$router.push({path: '/account/takeout'});
				let _this = this;
				android('startPageWithCallback', {
					url: config.staticURL + '/#/account/takeout',
					start_type:1,
					data:'',
					display:{
						title:'取出'
					}
				}, function () {
					_this.getDetail();
				});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Account.vue